module.exports = __webpack_public_path__ + "media/videos/term-bg-2-19a05099.jpg";